import React from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router";

import BadiLogo from "components/Icons/BadiLogo";

import { getRelativePath } from "base/shared/Utils";

import { LogoWrapper } from "./styled-components";

const Logo = ({ lister, router, dataQa, updateShowDistribution }) => {
  const homeLinkPath = lister ? "/overview" : "/";
  const checkDistributionNav = () => {
    const pathname = router?.location?.pathname;
    if (pathname && pathname === homeLinkPath) {
      updateShowDistribution(true);
    }
  };
  return (
    <LogoWrapper data-qa={dataQa}>
      <Link onClick={checkDistributionNav} to={getRelativePath(homeLinkPath)}>
        <BadiLogo />
      </Link>
    </LogoWrapper>
  );
};

Logo.propTypes = {
  dataQa: PropTypes.string,
  lister: PropTypes.bool,
  router: PropTypes.object,
  updateShowDistribution: PropTypes.func,
};

Logo.defaultProps = {
  dataQa: "logo-badi",
  lister: false,
  router: {},
  updateShowDistribution: () => {},
};

export default withRouter(Logo);
